import { axiosInstancePrivateServicesFluxiUrl, axiosInstanceTemplates } from "../instance";
import { AxiosResponse } from "../interface";

export interface UploadImagePayload {
  file: string;
  folder: string;
  filename: string;
}

export const uploadImagesToS3 = async (payload: UploadImagePayload) => {
  const response = await axiosInstancePrivateServicesFluxiUrl.post("/s3-upload", payload);
    return response.data;
};

export const postImagenS3 = async () => {
  const response: AxiosResponse = await axiosInstanceTemplates.post(`/s3-partition`);
  return response.data;
};
